import React, { Component } from 'react'
import './styles.css'
class Row extends Component {
  render () {
    return (
      <div
        className={'Row Row-' + this.props.grid + ' Row-Gap-' + this.props.gap + ' clearfix'}>{this.props.children}</div>
    )
  }
}
Row.defaultProps = {
  grid: 12,
  gap: 'small'
}
export default Row
